import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/scss/index.scss';
import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );

const root = createRoot(document.getElementById('root')!);
root.render(<App />);

// const container = document.getElementById("root")!;
// const root = createRoot(container);

// root.render(
//   // <React.StrictMode>
//     <App />
//   // </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
